module.exports = __webpack_public_path__ + "img/3.b664f9ff.jpg";